<div
  class="px-[18px] pb-[30px]"
  [class.pointer-events-none]="!collapsable"
  [class.pb-0]="!collapsable"
>
  <mat-expansion-panel [expanded]="isOpen" hideToggle [disabled]="!collapsable">
    <mat-expansion-panel-header (click)="toggleContent()">
      <div class="flex justify-between items-center w-full">
        <div class="flex items-center">
          <div class="setting-name">{{ name }}</div>
          @if (tag) {
            <span class="setting-tag">{{ tag | translate }}</span>
          }
        </div>
        @if (collapsable) {
          <fa-icon
            class="text-sm opacity-50"
            [icon]="'chevron-down'"
            [class.rotated]="isOpen"
          ></fa-icon>
        }
      </div>
    </mat-expansion-panel-header>
    <ng-content></ng-content>
  </mat-expansion-panel>
</div>
